<template>
    <div class="skill_div">
        <SkillsTarget></SkillsTarget>
    </div>
</template>
<script type="text/javascript">
import SkillsTarget from '@/components/skill_page/skill_target.vue'
import { mapActions } from 'vuex'

export default {
    components: {
        SkillsTarget
    },
    methods: {
        ...mapActions({
            set_domain_id: 'skill/set_domain_id',
        })
    },
    created: function () {
        this.set_domain_id(this.$route.params.id)
    }
}



</script>
<style type="text/css">

</style>

